import React, { useEffect } from "react";
import withPermissions from "permissions/withPermissions";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty, startCase } from "lodash";
import { TableCell, TableRow, Typography, Chip } from "@material-ui/core";
import { fetchReferralFormProfileResults } from "app/main/referralFormProfiles/actions/referralFormProfiles.actions";
import { REFERRAL_FORM_PROFILES_PAGE_SIZE_OPTIONS, REFERRAL_FORM_PROFILES_PAGE_SIZE, getAllReferralFormProfiles, isPageLoading, getErrorMessage, getReferralFormProfileSearchTerms, getPageInfo } from "app/main/referralFormProfiles/reducers/referralFormProfiles.reducers";
import PagingTable from "components/items/paging-table";

const OrgUnitReferralFormProfilesPageContent = ({ id, orgUnit, history }) => {
  const dispatch = useDispatch();
  const referralFormProfiles = useSelector(getAllReferralFormProfiles);
  const isEmptyResult = isEmpty(referralFormProfiles);
  const loading = useSelector(isPageLoading);
  const error = useSelector(getErrorMessage);
  const pageInfo = useSelector(getPageInfo);
  const searchParams = useSelector(getReferralFormProfileSearchTerms);
  const searchOrgUnitReferralFormProfiles = (pageNumber, pageSize, reload) => dispatch(fetchReferralFormProfileResults(
    id, pageNumber, pageSize, searchParams, reload || history.location.state?.forceLoad === true,
  ));

  useEffect(() => {
    searchOrgUnitReferralFormProfiles(1, REFERRAL_FORM_PROFILES_PAGE_SIZE, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // call back previous page if current page has only one record and it has been deleted.
    if (!loading && isEmptyResult && pageInfo?.pageNumber > 1) {
      searchOrgUnitReferralFormProfiles(pageInfo?.pageNumber - 1, REFERRAL_FORM_PROFILES_PAGE_SIZE, true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, isEmptyResult, pageInfo.pageNumber]);

  const onChangeRowsPerPage = pageSize => {
    searchOrgUnitReferralFormProfiles(1, pageSize, true);
  };

  const onChangePage = pageNumber => searchOrgUnitReferralFormProfiles(pageNumber + 1, pageInfo.pageSize, true);

  const onViewReferralFormProfile = referralFormProfileId => history.push(`/admin/org-units/${orgUnit.orgUnitType}/${id}/referralFormProfiles/${referralFormProfileId}`);

  const referralFormProfileItem = referralFormProfile => (
    <div className="flex">
      <div className="flex flex-col flex-1">
        <Typography variant="body2" className="font-bold">{referralFormProfile.name}{referralFormProfile.isDeprecated && (
          <Chip variant="outlined" size="small" label="Deprecated" className="mx-8" />
        )}
        </Typography>
        <div className="flex-row-container">
          <Typography variant="body2" className="mr-4">Form Configuration:</Typography>
          <Typography variant="body2" color="textPrimary">{referralFormProfile.formName ?? startCase(referralFormProfile.formType)}</Typography>
        </div>
        <div className="flex-row-container">
          <Typography variant="body2" className="mr-4">Default:</Typography>
          <Typography variant="body2" color="textPrimary">
            {referralFormProfile.isDefault ? "Yes" : "No"}
          </Typography>
        </div>
      </div>
    </div>
  );

  const renderTableRow = referralFormProfile => (
    <TableRow
      hover
      key={referralFormProfile?.id}
      onClick={() => onViewReferralFormProfile(referralFormProfile?.id)}
    >
      <TableCell>{referralFormProfileItem(referralFormProfile)}</TableCell>
    </TableRow>
  );

  return (
    <PagingTable
      loading={loading}
      error={error}
      data={referralFormProfiles}
      rowsPerPage={pageInfo.pageSize}
      pageSizeOptions={REFERRAL_FORM_PROFILES_PAGE_SIZE_OPTIONS}
      page={pageInfo.pageNumber - 1}
      count={pageInfo.totalRecords}
      onChangeRowsPerPage={onChangeRowsPerPage}
      onChangePage={onChangePage}
      tableRow={item => renderTableRow(item)}
      emptyMessage="No Referral Form Profile"
    />
  );
};

export default withPermissions("ReferralFormProfileDelete")(OrgUnitReferralFormProfilesPageContent);
